import Utils from '../../util';

export interface ResultSetConfigInterface {
  resultSetID: string | null;
  dropdownConfigEnabled: boolean;
  dropdownDefaults: Map<string, any>;
}

export class ResultSetConfig {
  resultSetID: string | null;
  dropdownConfigEnabled: boolean;
  dropdownDefaults: Map<string, any>;

  constructor(params: ResultSetConfigInterface = {
    resultSetID: null,
    dropdownConfigEnabled: false,
    dropdownDefaults: new Map()
  }) {
    this.resultSetID = params.resultSetID;
    this.dropdownConfigEnabled = params.dropdownConfigEnabled;
    if (Utils.isMap(params.dropdownDefaults)) {
      this.dropdownDefaults = params.dropdownDefaults;
    } else {
      this.dropdownDefaults = new Map();
    }
  }

  getJsonStringify() {
    return JSON.stringify(this, Utils.jsonStringifyMapReplacer);
  }
}

export enum ResultSetID {
  SUMMARY_OUTPUTS = 'summary-outputs',
  SUMMARY_INPUTS = 'summary-inputs',
  SUMMARY_PFD = 'summary-pfd',
  DETAILED_SUMMARY_OPTS = 'detailed-summary-opts',
  DETAILED_SUMMARY_PERIOD = 'detailed-summary-period',
  TECHNICAL = 'technical',
  INCOME_STATEMENT = 'income-statement',
  FINANCIAL_METRICS = 'financial-metrics'
}

export interface ResultSetIds {
  obj: Record<string, {
    resultSetID: string,
    userID: string,
    projectID: string
  }>
}